import React, { useEffect, useState } from "react";
import {
  useSearchParams,
	Link 
} from "react-router-dom";
import s from './student.module.css';
import {getData, postData} from '../middleware/apiMiddleware';
import { useNavigate, useParams } from "react-router-dom";

export default function Student() {
	const navigate = useNavigate();
	
	let params = useParams();
  let userId = params.userId;
	
	const [tutorGroups, setTutorGroups] = useState([]);
	const [tutorGroupData, setTutorGroupData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	
	const fetchData = async () => {
		getData('studentApi/getUserTutorGroup?userId=' + userId, navigate).then(res => {
			setTutorGroups(res.data);
		});
	}
	
	useEffect(() => {
		fetchData();
	}, []);
	
	const checkIfIntegerOnly = (str) => {
    return /^\d+$/.test(str);
  };
	
	const addTutorGroupToUser = async () => {
		if (checkIfIntegerOnly(tutorGroupData)) {
			let obj = { userId, tutorGroupId: tutorGroupData }
			
			await postData("studentApi/addTutorGroupId", obj, navigate); 
			fetchData();
		}
	}
	
	const removeTutorGroupToUser = async (tutorGroupId) => {
		let obj = { userId, tutorGroupId}
		
		await postData("studentApi/removeTutorGroupId", obj, navigate); 
		fetchData();
	}
	
	return (<div>
		<div>Student</div>
		<div>{userId}</div>
		
		<div style={{display:"flex", borderBottom:"1px solid #4b3f1b", margin:"0 20px"}}>
			<div style={{display:"flex", padding:"10px 0 0 0"}}>
				<div className={s.nonClickableTitle}>
					<span>Tutor Group:</span>
				</div>
			</div>
			<div className={s.itemHolder}>
				<input value={tutorGroupData} onChange={(e)=>{
					setTutorGroupData(e.target.value);
				}} />
				<div className={(tutorGroupData && !isLoading) ? s.btnActive : s.btnInactive} onClick={addTutorGroupToUser}>
					add
				</div>
			</div>
		</div>
		
		<div style={{textAlign:"left", margin:"20px"}}>
			{
				tutorGroups.map((t, index) => (<div
					className={(index%2==0) ? s.rowOdd : s.rowEven}
					>
					<div style={{width:"50px"}}>{t.tutorGroupId}</div>
					<div style={{width:"600px"}}>{t.title}</div>
					<div style={{width:"200px"}}>{t.startDate}</div>
					<div style={{width:"200px"}}>{t.endDate}</div>
					
					<div className={s.btnActive} onClick={()=>removeTutorGroupToUser(t.tutorGroupId)}>
						remove
					</div>
					
					
				</div>))
			}
		</div>
	
	</div>);
}

